module.exports = __webpack_public_path__ + "static/media/missingItem_icon.8700bded.png";